import { render, staticRenderFns } from "./riskConfirmLog.vue?vue&type=template&id=53f2fea2&scoped=true"
import script from "./riskConfirmLog.vue?vue&type=script&lang=js"
export * from "./riskConfirmLog.vue?vue&type=script&lang=js"
import style0 from "./riskConfirmLog.vue?vue&type=style&index=0&id=53f2fea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2fea2",
  null
  
)

export default component.exports